import { Utilities as utilities } from '@truckdown/framework';

export class ResultModel<T> {
    constructor();
    constructor(json: any, converter: (dt: any) => T | null);
    constructor(json?: any, converter?: (dt: any) => T | null) {
        if (json && converter) {
            this.cnt = utilities.json.getNumberValue(json, 'cnt', 0);
            this.res = utilities.json.getArrayValue(json, converter, 'res', []);
        }
    }

    cnt: number = 0;
    res: T[] = [];
}